import useSWRMutation from "swr/mutation";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";
import { useSWRConfig } from "swr";

export function useBuyItem(shopItemId) {
  const axiosClient = useAxiosWithAuth();
  const { mutate } = useSWRConfig();
  const { isMutating, trigger, data, error } = useSWRMutation(
    [`/store/${shopItemId}/buy`],
    ([path], { arg: { itemId, quantity, price, priceCurrency } }) =>
      axiosClient.wrap(
        axiosClient.post(path, { itemId, quantity, price, priceCurrency })
      ),
    {
      onSuccess: () => {
        mutate(() => ["user/tico-balance"]);
      },
    }
  );
  return {
    trigger,
    isMutating,
    data,
    error,
  };
}
